<template>
    <section class="max-w-screen-xl mx-auto px-4 relative mb-20">
        <!-- Cross Lines Background -->
        <div class="absolute inset-0 opacity-30 pointer-events-none">
            <div class="grid-background"></div>
        </div>

        <!-- Content with relative positioning to appear above background -->
        <div class="relative z-10">
            <!-- Header Section -->
            <div class="text-center">
                <div class="max-w-max mx-auto relative">
                    <NuxtImg src="/images/circuit.png" width="298" height="180" alt="Shopping Bag"
                        class="w-40 sm:w-56 md:w-72 lg:w-[298px] h-auto" loading="lazy" />
                    <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 
                 flex items-center justify-center 
                 w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 
                 rounded-2xl bg-[image:var(--primary-gradient)]">
                        <NsLogo name="NsThirdPartyToolsLogo" class="w-6 sm:w-8 md:w-10 h-auto" />
                    </div>
                </div>

                <!-- Heading -->
                <h2 class="text-xl sm:text-2xl md:text-3xl text-[var(--text-secondary)] 
               font-bold mb-4 px-2">
                    Effortless Integration of Third-Party Tools in Your Nuxt Store
                </h2>
                <p class="text-sm sm:text-base md:text-lg lg:text-xl text-[var(--text-gray)] 
               max-w-4xl mx-auto mb-6 md:mb-10 px-2">
                    Enhance E-commerce experience with Seamless External Service Integration
                </p>

                <Button unstyled label="Learn More" iconPos="left" class="group !rounded-xl !px-4 sm:!px-5 
         bg-[image:var(--primary-gradient)] hover:bg-[image:var(--primary-gradient-reverse)]
         transition-all duration-1000 ease-in-out
         !py-2.5 sm:!py-3 font-semibold
         text-[var(--text-secondary)] w-full max-w-[280px]
         flex items-center justify-center gap-2 sm:gap-3 
         sm:w-auto text-sm sm:text-base overflow-hidden mx-auto mb-10 sm:mb-0">

                        <span class="flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 
             rounded-full bg-white 
             transform transition-all duration-1000 ease-in-out 
             group-hover:translate-x-28">
                            <i class="pi pi-angle-right text-green-500 font-bold text-sm sm:text-lg"></i>
                        </span>
                        <span class="transition-all duration-1000 ease-in-out group-hover:-translate-x-1/2">
                            Learn More
                        </span>
                    </Button>
            </div>

            <!-- Tools Integration Layout -->
            <div class="relative">
                <!-- Mobile Layout (sm and below) -->
                <div class="block md:hidden">
                    <!-- Center NuxtStore -->
                    <div class="flex justify-center mb-8">
                        <div
                            class="w-[280px] h-[160px] bg-[var(--background-btn)] rounded-xl flex flex-col gap-3 items-center justify-center">
                            <NuxtImg src="/logos/nuxtstore-logo.svg" alt="Nuxt Store Logo" width="70" height="70"
                                class="mr-2" loading="lazy" />
                            <p class="text-[var(--text-gray)] text-lg">Nuxt<span
                                    class="font-bold text-[var(--text-secondary)]">Store</span></p>
                        </div>
                    </div>

                    <!-- Tools Grid for Mobile -->
                    <div class="grid grid-cols-1 gap-6">
                        <!-- Loyalty And Rewards -->
                        <div class="flex flex-col items-center text-center">
                            <h3 class="text-lg font-semibold mb-3 text-[var(--text-secondary)]">Loyalty And Rewards</h3>
                            <div class="flex gap-3 justify-center">
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsSmile" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">smile.io</p>
                                </div>
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsLoyaltyLion" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">LoyaltyLion</p>
                                </div>
                            </div>
                        </div>

                        <!-- Payment Portal -->
                        <div class="flex flex-col items-center text-center">
                            <h3 class="text-lg font-semibold mb-3 text-[var(--text-secondary)]">Payment Portal</h3>
                            <div class="flex gap-3 justify-center">
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsPaypal" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Paypal</p>
                                </div>
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsStripe" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Stripe</p>
                                </div>
                            </div>
                        </div>

                        <!-- Customer Support -->
                        <div class="flex flex-col items-center text-center">
                            <h3 class="text-lg font-semibold mb-3 text-[var(--text-secondary)]">Customer Support And
                                Chat</h3>
                            <div class="flex gap-3 justify-center">
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsZendesk" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Zendesk</p>
                                </div>
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsIntercom" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Intercom</p>
                                </div>
                            </div>
                        </div>

                        <!-- Search And Personalization -->
                        <div class="flex flex-col items-center text-center">
                            <h3 class="text-lg font-semibold mb-3 text-[var(--text-secondary)]">Search And
                                Personalization</h3>
                            <div class="flex gap-3 justify-center">
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsKlevu" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Klevu</p>
                                </div>
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsAlgolia" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Algolia</p>
                                </div>
                            </div>
                        </div>

                        <!-- Analytics And Insights -->
                        <div class="flex flex-col items-center text-center">
                            <h3 class="text-lg font-semibold mb-3 text-[var(--text-secondary)]">Analytics And Insights
                            </h3>
                            <div class="flex gap-3 justify-center">
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsHotjar" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Hotjar</p>
                                </div>
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsGoogleAnalytics" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Google Analytics</p>
                                </div>
                            </div>
                        </div>

                        <!-- Product Reviews -->
                        <div class="flex flex-col items-center text-center">
                            <h3 class="text-lg font-semibold mb-3 text-[var(--text-secondary)]">Product Reviews And
                                Ratings</h3>
                            <div class="flex gap-3 justify-center">
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsYotpo" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Yotpo</p>
                                </div>
                                <div class="max-w-[80px]">
                                    <div
                                        class="w-[80px] h-[60px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsTrustPilot" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm text-[var(--text-gray)]">Trustpilot</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Desktop Layout (md and above) -->
                <div class="hidden md:block">
                    <!-- Top Row -->
                    <div class="flex justify-between items-start mb-12 lg:mb-16 xl:px-12 translate-y-32">
                        <!-- Top Left Store -->
                        <div class="flex flex-col items-start">
                            <h3 class="text-lg lg:text-xl font-semibold mb-3 text-[var(--text-secondary)]">Loyalty And
                                Rewards</h3>
                            <div class="flex gap-3">
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsSmile" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">smile.io</p>
                                </div>
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsLoyaltyLion" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">LoyaltyLion</p>
                                </div>
                            </div>
                        </div>

                        <!-- Top Right Store -->
                        <div class="flex flex-col items-start">
                            <h3
                                class="text-lg lg:text-xl font-semibold text-[var(--text-secondary)] max-w-[150px] lg:max-w-[188px] mb-3">
                                Payment Portal</h3>
                            <div class="flex gap-3">
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsPaypal" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Paypal</p>
                                </div>
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsStripe" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Stripe</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Center Section -->
                    <div class="flex justify-center mb-12 lg:mb-16">
                        <div
                            class="relative w-[280px] lg:w-[314px] h-[160px] lg:h-[184px] bg-[var(--background-btn)] rounded-xl flex flex-col gap-3 items-center justify-center">
                            <!-- Connection Images -->
                            <NuxtImg src="/images/third-party-tools/loyality-rewards.png" width="208" height="156.5"
                                alt="loyalty rewards"
                                class="absolute bottom-[86px] right-full min-w-max hidden xl:block" loading="lazy" />
                            <NuxtImg src="/images/third-party-tools/customer-support.png" width="208" height="156.5"
                                alt="customer support" class="absolute right-full min-w-max top-1/2 hidden xl:block" />
                            <NuxtImg src="/images/third-party-tools/payment-portal.png" width="208" height="156.5"
                                alt="payment portal"
                                class="absolute left-full bottom-[86px] min-w-max hidden xl:block" loading="lazy" />
                            <NuxtImg src="/images/third-party-tools/search-personalization.png" width="208"
                                height="156.5" alt="search personalization"
                                class="absolute left-full top-[95px] min-w-max hidden xl:block" loading="lazy" />
                            <NuxtImg src="/images/third-party-tools/analytics-insights.png" width="208" height="156.5"
                                alt="analytics insights"
                                class="absolute top-full -left-[45px] min-w-max hidden xl:block" loading="lazy" />
                            <NuxtImg src="/images/third-party-tools/product-reviews.png" width="208" height="156.5"
                                alt="product reviews" class="absolute top-full left-1/2 min-w-max hidden xl:block" loading="lazy" />

                            <NuxtImg src="/logos/nuxtstore-logo.svg" alt="Nuxt Store Logo" width="90" height="90"
                                class="mr-2" loading="lazy" />
                            <p class="text-[var(--text-gray)] text-lg lg:text-xl">Nuxt<span
                                    class="font-bold text-[var(--text-secondary)]">Store</span></p>
                        </div>
                    </div>

                    <!-- Middle Row -->
                    <div class="flex justify-between items-start mb-12 lg:mb-12 xl:px-12 -translate-y-2">
                        <!-- Middle Left Store -->
                        <div class="flex flex-col items-start">
                            <h3
                                class="text-lg lg:text-xl font-semibold text-[var(--text-secondary)] max-w-[160px] lg:max-w-[206px] mb-3">
                                Customer Support And Chat</h3>
                            <div class="flex gap-3">
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsZendesk" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Zendesk</p>
                                </div>
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsIntercom" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Intercom</p>
                                </div>
                            </div>
                        </div>

                        <!-- Middle Right Store -->
                        <div class="flex flex-col items-start">
                            <h3
                                class="text-lg lg:text-xl font-semibold text-[var(--text-secondary)] max-w-[150px] lg:max-w-[188px] mb-3">
                                Search And Personalization</h3>
                            <div class="flex gap-3">
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsKlevu" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Klevu</p>
                                </div>
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsAlgolia" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Algolia</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Bottom Row -->
                    <div class="flex justify-around items-start xl:px-32 ">
                        <!-- Bottom Left Store -->
                        <div class="flex flex-col items-center text-center">
                            <h3
                                class="text-lg lg:text-xl font-semibold text-[var(--text-secondary)] max-w-[150px] lg:max-w-[188px] mb-3">
                                Analytics And Insights</h3>
                            <div class="flex gap-3">
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsHotjar" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Hotjar</p>
                                </div>
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsGoogleAnalytics" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Google Analytics</p>
                                </div>
                            </div>
                        </div>

                        <!-- Bottom Right Store -->
                        <div class="flex flex-col items-center text-center">
                            <h3
                                class="text-lg lg:text-xl font-semibold text-[var(--text-secondary)] max-w-[150px] lg:max-w-[188px] mb-3">
                                Product Reviews And Ratings</h3>
                            <div class="flex gap-3">
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsYotpo" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Yotpo</p>
                                </div>
                                <div class="max-w-[80px] lg:max-w-[90px]">
                                    <div
                                        class="w-[80px] lg:w-[90px] h-[60px] lg:h-[65px] bg-[var(--background-btn)] rounded-xl mb-2 flex items-center justify-center">
                                        <NsLogo name="NsTrustPilot" class="w-8 h-8" />
                                    </div>
                                    <p class="text-sm lg:text-base text-[var(--text-gray)]">Trustpilot</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const NsLogo = defineAsyncComponent(() => import('./NsLogo.vue'));

const stores = ref([
    { id: 1, title: 'nuxt store', items: [1, 2] },
    { id: 2, title: 'nuxt store', items: [1, 2] },
    { id: 3, title: 'nuxt store', items: [1, 2] },
    { id: 4, title: 'nuxt store', items: [1, 2] },
    { id: 5, title: 'nuxt store', items: [1, 2] },
    { id: 6, title: 'nuxt store', items: [1, 2] }
])
</script>

<style scoped>
.grid-background {
    width: 100%;
    height: 100%;
    background-image:
        linear-gradient(rgba(17, 42, 29, 1) 1.30px, transparent 1.30px),
        linear-gradient(90deg, rgba(17, 42, 29, 1) 1.30px, transparent 1.30px);
    background-size: 80px 80px;
    background-position: 0 0;
}
</style>